import { Injectable, inject, ApplicationRef, ComponentRef, Type, createComponent } from '@angular/core';

export interface BrcDialogConfig {
  header: string;
  onClose?: () => void;
  style?: Partial<CSSStyleDeclaration>;
}

@Injectable({ providedIn: 'root' })
export class BrcDialogService {
  private dialogElement?: HTMLElement;
  private componentRef?: ComponentRef<unknown>;
  private appRef = inject(ApplicationRef);

  openDialog<T>(component: Type<T>, config: BrcDialogConfig): void {
    const { onClose, style, header } = config;
    this.closeDialog();

    const overlay = document.createElement('div');
    overlay.className = 'brc-dialog-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    `;

    const dialogBox = document.createElement('div');
    dialogBox.className = 'brc-dialog';
    dialogBox.style.cssText = `
      background: white;
      border-radius: 4px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.2);
      width: 50vw;
      max-height: 80vh;
      display: flex;
      flex-direction: column;
    `;

    if (style) {
      Object.assign(dialogBox.style, style);
    }
    const headerDiv = document.createElement('div');
    headerDiv.className = 'brc-dialog-header';
    headerDiv.style.cssText = `
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 72px;
      padding: 16px 40px;
    `;

    const headerText = document.createElement('span');
    headerText.style.fontSize = 'x-large';
    headerText.textContent = header;
    const closeButton = document.createElement('button');
    closeButton.className = 'brc-dialog-close';
    closeButton.setAttribute('aria-label', 'Close');
    closeButton.style.cssText = 'background:none;border:none;font-size:xx-large;cursor:pointer;';
    closeButton.textContent = '\u00d7';
    headerDiv.append(headerText, closeButton);

    const contentDiv = document.createElement('div');
    contentDiv.className = 'brc-dialog-content';
    contentDiv.style.cssText = 'flex:1;overflow:auto;padding:16px;border-top:1px solid var(--p-dialog-border-color);';

    dialogBox.appendChild(headerDiv);
    dialogBox.appendChild(contentDiv);
    overlay.appendChild(dialogBox);
    document.body.appendChild(overlay);
    this.dialogElement = overlay;

    this.componentRef = createComponent(component, { environmentInjector: this.appRef.injector });
    this.appRef.attachView(this.componentRef.hostView);
    contentDiv.appendChild(this.componentRef.location.nativeElement);

    closeButton.addEventListener('click', () => {
      this.closeDialog();
      onClose?.();
    });
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        this.closeDialog();
        onClose?.();
      }
    });
  }

  closeDialog(): void {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = undefined;
    }
    if (this.dialogElement) {
      this.dialogElement.remove();
      this.dialogElement = undefined;
    }
  }
}
